import { isNumber } from '../../Helpers/NumericHelper'
import { ExclamationCircleFilled } from '@ant-design/icons'
/**
 * @param {any} value
 * @param {boolean} showZeroValue
 * @param {boolean} highlightNegative
 * @param {string} extraClass  additional cssclass
 * @param {boolean} showLimitWarning
 */
export default function NumericCell(props) {
  const stringValue = props.value || (props.showZeroValue && props.value === 0) ? props.value : ''
  const negativeClass = isNumber(props.value) && props.value < 0 && props.highlightNegative ? 'negative-value' : ''
  const emptyClass = stringValue === '' ? 'empty-content' : ''
  const className = `count-box  ${negativeClass} ${emptyClass} ${props.extraClass ?? ''}`

  return (
    <div className={className}>
      <div>{stringValue}</div>
      {props.showLimitWarning && stringValue !== '' && <ExclamationCircleFilled className='limit-track-icon' />}
    </div>
  )
}
